// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HiAl","toggleWrap":"styles_toggleWrap__1W5Em","content":"styles_content__3uHR1","selectAreaCode":"styles_selectAreaCode__1MXio"};